import { useQuery } from '@tanstack/react-query';
import api from '@/services/api';
import type { Indicator } from '@/types/indicator';
import type { BuildingStats } from '@/types/building';

export function useIndicators(territoryCode: string | null) {
  return useQuery<Indicator[]>({
    queryKey: ['indicators', territoryCode],
    queryFn: async () => {
      const { data } = await api.get(`/territories/${territoryCode}/indicators`);
      return data.indicators;
    },
    enabled: !!territoryCode,
  });
}

export function useBuildingStats(territoryCode: string | null) {
  return useQuery<BuildingStats>({
    queryKey: ['building-stats', territoryCode],
    queryFn: async () => {
      const { data } = await api.get('/buildings/stats', {
        params: { territory_code: territoryCode },
      });
      return data;
    },
    enabled: !!territoryCode,
  });
}
